import { h, Component } from 'preact';

export default class Modal extends Component {
  constructor () {
    super();
    this.state = {};
  }

  render ({ title = 'Modal title', onUserClose }) {
    const { children } = this.props;

    return (
      <div className="w-modal">
        <div className="w-modal-container">
          <i onClick={onUserClose} role="none" className="w-modal-close" />
          <h3 className="w-modal-title">{title}</h3>
          <div>{children}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/generics/Modal.js